import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { purple } from "@mui/material/colors";

const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: purple[500],
    "&:hover": {
        backgroundColor: purple[700],
    },
}));

export default function UserCustomButton({ children, onClick }) {
    return (
        <ColorButton
            sx={{
                borderRadius: 1,
                background: "#4B59F7",
                whiteSpace: "nowrap",
                // padding: "12px 64px",
                color: "#fff",
                fontSize: "20px",
                outline: "none",
                border: "none",
                cursor: "pointer",
                transition: "all 0.3s ease-out",
                "&:hover": {
                    background: "#fff",
                    backgroundColor: "#0467FB",
                },
                // "@media screen and (max-width: 960px)": {
                //     width: "100%",
                // },
                pl: 2,
                pr: 2,
                textTransform: "none",
            }}
            size="small"
            onClick={onClick}
        >
            {children}
        </ColorButton>
    );
}
